export default {
    messages: {
        en: {
            heading: 'I\'m Max.',
            subheading: 'DEVELOPER & AUTHOR',
            buttonPortfolio: 'My Portfolio',
            philosophy: 'My Philosophy',
            buttonBook: 'My Books',
            cards: {
                love: {
                    title: 'Do what you love!',
                    text: 'Ever since touching my first book on the topic, programming became my favorite hobby. I have neither doubts nor any regrets that I chose my path that early: I am in nothing but love with the things I do every single day.',
                },
                learn: {
                    title: 'Never stop learning!',
                    text: 'Today, I am working on my PhD thesis and try to combine state-of-the-art AI with practical applications. I am mostly developing interactive applications and love all theory, team practice and scientific work.',
                },
                share: {
                    title: 'Share knowledge!',
                    text: 'Inspiring both children and adults to start getting into computer science and especially programming became my personal concern. That is why I have engaged in multiple projects dealing with effective education strategies in the given topics.',
                }
            },
        },
        de: {
            heading: "Ich bin Max.",
            subheading: "ENTWICKLER & AUTOR",
            buttonPortfolio: "Mein Portfolio",
            philosophy: "Meine Philosophie",
            buttonBook: "Meine Bücher",
            cards: {
                love: {
                    title: "Tue, was du liebst!",
                    text: "Seitdem ich mein erstes Buch zum Thema in die Hand genommen habe, ist Programmieren mein liebstes Hobby geworden. Ich bereue nicht, dass ich meinen Weg so früh eingeschlagen habe: Ich liebe die Dinge, die ich Tag für Tag tue."
                },
                learn: {
                    title: "Lerne jeden Tag!",
                    text: "Aktuell arbeite ich an meiner Doktorarbeit und versuche, modernste KI mit praktischen Anwendungen zu verbinden. Ich entwickle hauptsächlich interaktive Anwendungen und liebe Theorie, Teamarbeit und wissenschaftliches Arbeiten."
                },
                share: {
                    title: "Teile Wissen!",
                    text: "Andere dazu zu inspirieren, sich mit Informatik und insbesondere der Programmierung zu beschäftigen, ist mir ein persönliches Anliegen geworden. Deshalb habe ich mich in mehreren Projekten engagiert, die sich mit effektiven Bildungsstrategien in diesen Themenbereichen befassen."
                }
            }
        }
    },
}